import React from "react";

const Card = ({ ...props }) => {
  //   console.log(props.items, props.name, props.img, props.index);
  let id = props.name.split(" ").join("");
  //   console.log(id);
  let key = props.index;
  //   console.log(key, "KEYKEY");
  return (
    <div className="tab ">
      <input type="checkbox" id={key}></input>
      <label className="tab-label" htmlFor={key} id={id}>
        <div className="item-box">
          <div className="item-titles">
            <h2>{props.name}</h2>
            {props.name === "Rolls" && (
              <p style={{ fontSize: "0.6rem" }}>
                (All Roll's are made from Bun Paav)
              </p>
            )}
            <p>Tap me to see items</p>
          </div>
        </div>
        <div className="item-image">
          <img
            //   src={require('./logo.jpeg')}
            src={require(`../../images${props.img}`)}
            alt={id}
          ></img>
        </div>
      </label>

      <div className="tab-content" style={{ display: "block" }}>
        <ul className="menu-list">
          {props.items.map((item, key) => {
            let itemName = Object.keys(item);
            let itemPrice = item[itemName];

            return (
              <li className="menu-item" id="">
                <p className="item-name">{itemName}</p>
                <p className="price">{itemPrice} ₹</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Card;
